import { ExternalLink } from "lucide-react"
import { NavLink } from "react-router-dom"
import { VideoSlug } from "@/types/videos"

function VideoLink({ to }: { to: VideoSlug }) {
  return (
    <NavLink className="text-blue-500 mt-2 font-bold flex items-center gap-2 hover:text-blue-700 transition-colors" to={`/dashboard/resources#${to}`}>
      Watch the video instructions <ExternalLink className="size-4" />
    </NavLink>
  )
}

export default VideoLink